export default "__VITE_ASSET__R$A4UuoD__"